import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {UseGetObligationHistoryQueryParams} from './types';
import {getObligationHistory} from '../../services/getObligationHistory';

export const useGetObligationHistoryQuery = ({year}: UseGetObligationHistoryQueryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.OBLIGATION_HISTORY, year],
		queryFn: async ({signal}) => getObligationHistory({exercicio: year, signal}),
		enabled: !!year,
		retry: 2,
	});
